import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "address", "postcode", "homePhone", "mobile", "email"]

  connect() {
    if (this.hasSelectTarget) {
      $(this.selectTarget).on("select2:select", this.select.bind(this));
    }
  }

  disconnect() {
    if (this.hasSelectTarget) {
      $(this.selectTarget).off("select2:select", this.select.bind(this));
    }
  }

  async select() {
    const parentId = this.selectTarget.value
    if (!parentId) return

    try {
      const response = await fetch(`/parents/${parentId}/address.json`)
      if (!response.ok) throw new Error("Failed to fetch parent address")

      const data = await response.json()

      this.addressTarget.value = data.address || ""
      this.postcodeTarget.value = data.postcode || ""
      this.homePhoneTarget.value = data.home_phone || ""
      this.mobileTarget.value = data.mobile || ""
      this.emailTarget.value = data.email || ""
    } catch (error) {
      console.error("Error fetching parent info:", error)
    }
  }
}
